import { Button } from "@/components/ui/button"
import { Star, Truck, Shield, Leaf } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "@/context/Auth"
import Hero1 from "../../assets/images/hero/bg-hero.jpg"

export default function Hero() {
  const navigate = useNavigate()
  const { user } = useAuth()

  const handleShopCollection = () => {
    navigate("/shop")
  }

  const handleTakeSkinQuiz = () => {
    if (user) {
      navigate("/dashboard/analysis/skin")
    } else {
      navigate("/auth/login?redirect=/dashboard/analysis/skin")
    }
  }

  return (
    <section
      className="relative overflow-hidden bg-cover bg-center bg-no-repeat min-h-[85vh]"
      style={{ backgroundImage: `url(${Hero1})` }}
    >
      {/* Background overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex items-center justify-start min-h-[85vh] py-8 md:py-12 lg:py-0">

          {/* CONTENT */}
          <div className="space-y-8 max-w-2xl">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
                <Star className="w-4 h-4 fill-current" />
                Tested and Trusted
              </div>

              <h1 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
                Healthy Skin & Hair
                <span className="block text-secondary">Starts Here</span>
              </h1>

              <p className="text-lg text-white/90 max-w-lg">
                Discover our premium collection of clean, effective skin and hair care products
                formulated with natural ingredients for a healthy ravishing skin and hair.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={handleShopCollection}
                className="bg-primary hover:bg-primary/90 text-white px-8 py-3 text-lg"
              >
                Shop Collection
              </Button>

              {/* <Button
                onClick={handleTakeSkinQuiz}
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-primary px-8 py-3 text-lg"
              >
                Take Skin Quiz
              </Button> */}
            </div>

            {/* TRUST INDICATORS */}
            <div className="flex flex-wrap items-center gap-8 pt-8">
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-white" />
                <span className="text-sm text-white/90">Cruelty Free</span>
              </div>
              <div className="flex items-center gap-2">
                <Leaf className="w-5 h-5 text-white" />
                <span className="text-sm text-white/90">Natural Ingredients</span>
              </div>
              {/* <div className="flex items-center gap-2">
                <Truck className="w-5 h-5 text-white" />
                <span className="text-sm text-white/90">Free Shipping</span>
              </div> */}
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
